// CustomPopover.js
import React from 'react';
import { Popover, PopoverTrigger, PopoverContent, IconButton, PopoverArrow, useDisclosure } from '@chakra-ui/react';
import { CiCircleQuestion } from 'react-icons/ci';

const CustomPopover = ({ popoverText, placement = "right" }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Popover  
        placement={placement}
        isOpen={isOpen}
        onClose={onClose}
        closeOnBlur={true} 
    >
     
          <PopoverTrigger>
            <IconButton 
              className='popover-icon-button'
              icon={<CiCircleQuestion size={18} />} 
              aria-label="Info" 
              variant="outline" 
              onMouseEnter={onOpen} 
              onMouseLeave={onClose}
            />
          </PopoverTrigger>
          <PopoverContent className='info-popover-content' onMouseEnter={() => onClose()} onMouseLeave={onClose}>
            <PopoverArrow className='popover-arrow' />
            {popoverText}
          </PopoverContent>
       
    </Popover>
  );
};

export default CustomPopover;